module.exports = __webpack_public_path__ + "static/leanTo-0124e93a3fa9d3ec0f5363f0c1806fc4.jpeg";